import fetchService from "app/common/services/salesFetchService";
import type { ApiParams } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewTraffic/Types";

export const getMMXTrafficData = (params: ApiParams): Promise<any> => {
    return fetchService.get("widgetApi/MarketingMixTotal/TrafficSourcesOverview/PieChart", params);
};

// api calls for single mode
export const getSingleTotalVisitsData = (params: ApiParams): Promise<any> => {
    return fetchService.get("widgetApi/TrafficSourcesSearch/SearchVisitsOverview/SingleMetric", params);
};

export const getSingleOrganicVSPaid = (params: ApiParams): Promise<any> => {
    return fetchService.get("widgetApi/TrafficSourcesSearch/SearchOrganicPaidOverview/PieChart", params);
};

export const getSingleBrandedNonBranded = (params: ApiParams): Promise<any> => {
    return fetchService.get("widgetApi/TrafficSourcesSearchV2/BrandedKeywords/PieChart", params);
};

// api calls for compare mode
export const getCompareTotalVisitsData = (params: ApiParams): Promise<any> => {
    return fetchService.get("widgetApi/TrafficSourcesSearch/SearchVisitsOverview/Table", params);
};
export const getCompareOrganicVSPaid = (params: ApiParams): Promise<any> => {
    return fetchService.get("widgetApi/TrafficSourcesSearch/SearchOrganicPaidOverview/Table", params);
};
export const getCompareBrandedNonBranded = (params: ApiParams): Promise<any> => {
    return fetchService.get("widgetApi/TrafficSourcesSearchV2/BrandedKeywords/Table", params);
};
